import { render, staticRenderFns } from "./partyBuildingPosition.vue?vue&type=template&id=194ef8c4&scoped=true"
import script from "./partyBuildingPosition.vue?vue&type=script&lang=js"
export * from "./partyBuildingPosition.vue?vue&type=script&lang=js"
import style0 from "./partyBuildingPosition.vue?vue&type=style&index=0&id=194ef8c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194ef8c4",
  null
  
)

export default component.exports